"use client";

import { createContext, useState } from "react";
import type { Level, WorldMap } from "../server/domain/map";
import { useLocalStorage } from "usehooks-ts";

type MapContextType = {
  map: WorldMap | undefined;
  selectedLevelInfo: { level: Level; map: WorldMap } | undefined;
  levelRocketLoading: boolean;
  setMap: (map: WorldMap | undefined) => void;
  setSelectedLevelInfo: (selectedLevelInfo: { level: Level; map: WorldMap } | undefined) => void;
  setLevelRocketLoading: (levelRocketLoading: boolean) => void;
  animationsEnabled: boolean | undefined;
  setAnimationsEnabled: (animationsEnabled: boolean) => void;
};

export const MapContext = createContext<MapContextType>({
  map: undefined,
  selectedLevelInfo: undefined,
  levelRocketLoading: false,
  setMap: () => undefined,
  setSelectedLevelInfo: () => undefined,
  setLevelRocketLoading: () => undefined,
  animationsEnabled: undefined,
  setAnimationsEnabled: () => undefined,
});

export function MapProvider({ children }: { children: React.ReactNode }) {
  const [map, setMap] = useState<WorldMap | undefined>();
  const [selectedLevelInfo, setSelectedLevelInfo] = useState<
    { level: Level; map: WorldMap } | undefined
  >();
  const [levelRocketLoading, setLevelRocketLoading] = useState(false);
  const [animationsEnabled, setAnimationsEnabled] = useLocalStorage("animationsEnabled", true);

  return (
    <MapContext.Provider
      value={{
        map,
        setMap,
        selectedLevelInfo,
        setSelectedLevelInfo,
        levelRocketLoading,
        setLevelRocketLoading,
        animationsEnabled,
        setAnimationsEnabled,
      }}
    >
      {children}
    </MapContext.Provider>
  );
}
